import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type SetCompanyFaviconRequest as SchemaSetCompanyFaviconRequest } from '../schemas/SetCompanyFaviconRequest';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Company
 */
export const SetCompanyFaviconContentType = 'application/json' as const;
export type SetCompanyFaviconRequest = SchemaSetCompanyFaviconRequest;
export type SetCompanyFaviconResponses = LinkCommonErrorResponses & {};
export type SetCompanyFaviconResponseSuccess = undefined;
export type SetCompanyFaviconSearchParams = undefined;
export type SetCompanyFaviconPathParameters = undefined;
export const SetCompanyFaviconUrl = '/company/favicon' as const;
export const SetCompanyFaviconMethod = 'POST' as const;
export const getSetCompanyFaviconUrl = (_params?: SetCompanyFaviconPathParameters) => SetCompanyFaviconUrl;
